import axios from "axios";
import env from "../config/env";
import { Message } from "element-ui";
import router from "../router";
import {
  showFullScreenLoading,
  tryHideFullScreenLoading
} from "../api/loading";
const AJAX = axios.create({
  baseURL: env.baseUrl,
  timeout: 30000,
  withCredentials: env.credential
});

//请求拦截器
AJAX.interceptors.request.use(
  function(config) {
    // showFullScreenLoading(config);

    let token;
    config.headers["Authorization"] = "Basic c2FiZXI6c2FiZXJfc2VjcmV0";
    if (localStorage.token) {
      token = localStorage.token;
      // token = localStorage.getItem('token');
      config.headers["X-AccessToken"] = token;
    } else {
      token = "";
    }
    if (config.method == "get") {
    }
    if (config.method == "post") {
      console.log(config)
      // config.data = {};
    }
    return config;
  },
  function(error) {
    console.log("请求拦截器---", error);
    return Promise.reject(error);
  }
);

//响应拦截器
AJAX.interceptors.response.use(
  function(response) {
    // tryHideFullScreenLoading();
    // loadingInstance && loadingInstance.close();
    if (response.headers["x-accesstoken"]) {
      localStorage.setItem("token", response.headers["x-accesstoken"]);
    }
    if(response.data.data == null){
      response.data.data = ''
    }
    switch (response.data.code) {
      case 900002:
        localStorage.setItem("token", "");
        localStorage.setItem("bread", []);
        localStorage.setItem("userInfo", []);
        localStorage.setItem("menu", []);
        localStorage.setItem("org_id", "");
        localStorage.setItem("school_id", "");
        localStorage.setItem("use_org", "");
        localStorage.setItem("is_org_admin", "");

        setTimeout(() => {
          router.push({ path: "/user/login" });
        });
        break;
      case 90005:
        Message({
          type: "error",
          message: "您没有此操作权限"
        });
        break;
      case 90007:
        Message({
          type: "error",
          message: "验证失败"
        });
        break;
    }
    if (
      (response.config.url == "/login" ||
        response.config.url == "/login/sms_login" ||
        response.config.url == "/login/set_password") &&
      response.data.data
    ) {
      // localStorage.setItem("org_id", response.data.data.org_id);
    } else if (
      response.config.url == "/staffs/get_role_menu" &&
      response.data.data
    ) {
      localStorage.setItem(
        "school_id",
        JSON.stringify(response.data.data.school_list)
      );
      localStorage.setItem("use_org", response.data.data.use_org);
      localStorage.setItem("is_org_admin", response.data.data.is_org_admin);
    }
    return response.data;
  },
  function(error) {
    if (error && error.response) {
      Message({
        type: "error",
        message: "网络出错"
      });
      // tryHideFullScreenLoading();
    }
    return Promise.reject(error);
  }
);

//定义Get Post File
export default {
  get(url, param, headers = {}) {
    return AJAX.get(url, {
      params: {
        ...param
      },
      headers
    });
  },
  post(url, param, headers = {}) {
    console.log(url, param, headers)
    return AJAX.post(
      url,
      {
        ...param
      },
      {
        headers
      }
    );
  },
  put(url, param = null, headers = {}) {
    return AJAX.put(url, param, {
      headers
    });
  },
  file(url, param = null, headers = {}) {
    return AJAX.post(url, param, {
      headers: Object.assign(
        {
          "Content-Type": "multipart/form-data"
        },
        headers
      )
    });
  },
  delete(url, param = null, headers = {}) {
    return AJAX.delete(url, {
      param,
      headers: Object.assign(
        {
          "Content-Type": "multipart/form-data"
        },
        headers
      )
    });
  }
};



// WEBPACK FOOTER //
// ./src/common/request.js